export default __webpack_public_path__ + "invalid-record-voilet-icon.svg";